import { render, staticRenderFns } from "./subeditCategory.vue?vue&type=template&id=e4a1a540&"
import script from "./subeditCategory.vue?vue&type=script&lang=js&"
export * from "./subeditCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports